import React from "react";
import { Button, Table, Alert, Spin } from "antd";
import { capitalizeFirstLetter } from "Pages/StudentPortfolio/StudentCommentSection/StudentCommentListingBox";
const StudentHTMLPage = ({ data, loading, error }: any) => {
  const handleDownload = async (s3Url: string) => {
    try {
      const response = await fetch(s3Url);
      const html = await response.text();
      const newWindow = window.open("", "_blank");
      if (newWindow) {
        newWindow.document.open();
        newWindow.document.write(html);
        newWindow.document.close();
        newWindow.print();
      }
    } catch (error) {
      console.error("Failed to load HTML preview:", error);
    }
  };

  const columns = [
    {
      title: "Test Title",
      dataIndex: "testTitle",
      key: "testTitle",
      render: (_: any, record: any) => <span>{record?.testTitle}</span>,
    },
    {
      title: "Subject",
      dataIndex: "subject",
      key: "subject",
      render: (_: any, record: any) => (
        <span>{record.subject && capitalizeFirstLetter(record.subject)}</span>
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (_: any, record: any) => (
        <Button type="primary" onClick={() => handleDownload(record.s3Url)}>
          View
        </Button>
      ),
    },
  ];

  if (loading) return <Spin tip="Loading student HTML..." />;
  if (error)
    return (
      <Alert
        message="Failed to load data"
        description={String(error)}
        type="error"
        showIcon
      />
    );

  return (
    <div style={{ padding: 20 }}>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="subject"
        pagination={false}
      />
    </div>
  );
};

export default StudentHTMLPage;
